import { render, staticRenderFns } from "./TripInvoices.vue?vue&type=template&id=b8172ea4&scoped=true"
import script from "./TripInvoices.vue?vue&type=script&lang=js"
export * from "./TripInvoices.vue?vue&type=script&lang=js"
import style0 from "./TripInvoices.vue?vue&type=style&index=0&id=b8172ea4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8172ea4",
  null
  
)

export default component.exports